import { auth } from './auth'
import api from '@/api/client'

const GUEST_KEY = 'blog_history_guest'
const MAX_ITEMS = 50

let guestCache = loadGuestHistory()
let serverCache = []
let serverCount = 0

function loadGuestHistory() {
  try {
    const raw = localStorage.getItem(GUEST_KEY)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

function saveGuestHistory(list) {
  localStorage.setItem(GUEST_KEY, JSON.stringify(list))
}

function notifyChange() {
  window.dispatchEvent(new Event('history-change'))
}

export const historyStore = {
  async addRecord(article) {
    if (!article) return

    const record = {
      id: article.id,
      title: article.title,
      category: article.subCategory || article.category,
      type: article.type || 'tech',
      viewedAt: new Date().toISOString()
    }

    if (auth.isLoggedIn) {
      try {
        await api.addHistory(record)
        await this.fetchHistory()
      } catch {
        // 静默失败，不影响阅读
      }
      return
    }

    let list = guestCache.filter(item => item.id !== article.id)
    list.unshift(record)
    if (list.length > MAX_ITEMS) {
      list = list.slice(0, MAX_ITEMS)
    }
    guestCache = list
    saveGuestHistory(list)
    notifyChange()
  },

  async fetchHistory(limit = 50) {
    if (!auth.isLoggedIn) {
      return guestCache.slice(0, limit)
    }
    try {
      const res = await api.getHistory(limit)
      serverCache = res.data.list || []
      serverCount = res.data.count || 0
      notifyChange()
      return serverCache
    } catch {
      serverCache = []
      serverCount = 0
      return []
    }
  },

  getHistory(limit) {
    const list = auth.isLoggedIn ? serverCache : guestCache
    return limit ? list.slice(0, limit) : list
  },

  async clearHistory() {
    if (auth.isLoggedIn) {
      await api.clearHistory()
      serverCache = []
      serverCount = 0
    } else {
      guestCache = []
      localStorage.removeItem(GUEST_KEY)
    }
    notifyChange()
  },

  getCount() {
    return auth.isLoggedIn ? serverCount : guestCache.length
  }
}

window.addEventListener('auth-change', () => {
  if (auth.isLoggedIn) {
    historyStore.fetchHistory()
  } else {
    serverCache = []
    serverCount = 0
    notifyChange()
  }
})

export default historyStore
